<section class="av-card p-4 d-flex flex-column gap-3" data-testid="organization-detail-header">
  <div class="d-flex flex-wrap align-items-start justify-content-between gap-3">
    <div class="d-flex flex-column gap-1">
      <a class="av-meta d-inline-flex align-items-center gap-1 back-link" routerLink="/organizations">
        <mat-icon aria-hidden="true">arrow_back</mat-icon>
        {{ 'backoffice.organizations.detail.back' | translate }}
      </a>

      <h2 class="av-section-title m-0" data-testid="organization-detail-name">
        {{ facade.organization()?.displayName || unresolved }}
      </h2>

      <p class="av-meta m-0">{{ facade.organization()?.domain || unresolved }}</p>
    </div>

    <div class="d-flex align-items-center gap-2">
      @if (facade.organization(); as organization) {
        <av-status-chip
          [label]="organization.statusLabelKey | translate"
          [tone]="organization.statusTone"
        ></av-status-chip>

        @if (organization.rootIsMissing) {
          <av-status-chip
            [label]="'backoffice.common.root_missing' | translate"
            tone="danger"
          ></av-status-chip>
        }
      }

      <button type="button" class="av-btn" (click)="reload()">
        <mat-icon aria-hidden="true">refresh</mat-icon>
        {{ 'backoffice.common.actions.refresh' | translate }}
      </button>
    </div>
  </div>

  <p class="av-meta m-0" data-testid="organization-scope-note">{{ 'backoffice.organizations.detail.scope_note' | translate }}</p>
</section>

<section class="av-card mt-3 d-flex flex-column" data-testid="organization-detail-body">
  @switch (facade.state()) {
    @case ('error') {
      <div class="p-4">
        <av-empty-state
          icon="error_outline"
          [title]="'backoffice.organizations.detail.error.title' | translate"
          [message]="'backoffice.organizations.detail.error.message' | translate"
        ></av-empty-state>
      </div>
    }
    @case ('ready') {
      <nav class="tab-bar d-flex flex-wrap" role="tablist" data-testid="organization-tabs">
        @for (tab of tabs; track tab.id) {
          <button
            type="button"
            role="tab"
            class="tab-button d-inline-flex align-items-center gap-2"
            [class.is-active]="activeTab() === tab.id"
            [attr.aria-selected]="activeTab() === tab.id"
            [attr.data-tab]="tab.id"
            (click)="selectTab(tab.id)"
          >
            <mat-icon aria-hidden="true">{{ tab.icon }}</mat-icon>
            {{ tab.label | translate }}
          </button>
        }
      </nav>

      <div class="p-4" data-testid="organization-tab-panel">
        @switch (activeTab()) {
          @case ('edit') {
            <av-organization-edit></av-organization-edit>
          }
          @case ('notes') {
            <av-organization-notes></av-organization-notes>
          }
          @case ('subscription') {
            <av-organization-subscription
              [organizationId]="facade.organizationId()"
            ></av-organization-subscription>
          }
          @case ('licences') {
            <av-organization-licences [organizationId]="facade.organizationId()"></av-organization-licences>
          }
          @case ('devices') {
            <av-organization-devices [organizationId]="facade.organizationId()"></av-organization-devices>
          }
          @case ('invoices') {
            <av-organization-invoices [organizationId]="facade.organizationId()"></av-organization-invoices>
          }
          @case ('payments') {
            <av-organization-payments [organizationId]="facade.organizationId()"></av-organization-payments>
          }
          @default {
            <av-organization-overview></av-organization-overview>
          }
        }
      </div>
    }
    @default {
      <div class="p-4">
        <av-empty-state
          icon="hourglass_empty"
          [title]="'backoffice.organizations.detail.loading.title' | translate"
          [message]="'backoffice.organizations.detail.loading.message' | translate"
        ></av-empty-state>
      </div>
    }
  }
</section>
